import classNames from 'classnames'
import { type ReactNode, type HTMLAttributes } from 'react'

type TextSize = '200' | '300' | '400'
type TextWeight = 'regular' | 'medium' | 'semibold' | 'bold'

interface TextProps extends HTMLAttributes<HTMLSpanElement> {
	size?: TextSize
	weight?: TextWeight
	children: ReactNode
}

const Text = ({
	size = '300',
	weight,
	children,
	className,
	...rest
}: TextProps) => {
	return (
		<span
			className={classNames(
				`mds-typography-body-${size}`,
				weight && `mds-typography-font-weight-${weight}`,
				className
			)}
			{...rest}
		>
			{children}
		</span>
	)
}

export { Text }
